module.exports = __webpack_public_path__ + "static/img/icon4.7e6ed59.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/fxcp_result/images/icon4.png
// module id = NFI7
// module chunks = 21